import React, { useEffect, useState } from 'react'
import './Testimonial.css'
import testi1 from './testi-img/3-27.jpg'
import testi2 from './testi-img/4-18.jpg'
import testi3 from './testi-img/5-27.jpg'


const testimonials = [
    {
        id: 1,
        text: "AIZO Plug has been a game-changer for our EV charging needs. Their high-quality,reliable solutions and exceptional customer service have made them our go-tochoice. Highly recommend!",
        name: "Jeff Smith",
        role: "client",
        image: "https://kitpro.site/volthub/wp-content/uploads/sites/264/2024/08/3-27.jpg", // Placeholder for user image
    },
    {
        id: 2,
        text: "We’ve trusted AIZO Plug since 2015 for our EV charging needs. Their expertise andtop-quality products ensure seamless, sustainable charging. A reliable choice forbusinesses!",
        name: "Amora Lin",
        role: "client",
        image: "https://kitpro.site/volthub/wp-content/uploads/sites/264/2024/08/4-18.jpg",
    },
    {
        id: 3,
        text: "AIZO Plug consistently delivers exceptional EV charging solutions.Theirmanufacturing expertise and reliable products have made them our trusted partnerfor sustainable energy solutions!",
        name: " Brandon Salim",
        role: "client",
        image: "https://kitpro.site/volthub/wp-content/uploads/sites/264/2024/08/5-27.jpg",
    },
];
const Testimonial = () => {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(false);

    // Auto-play logic
    useEffect(() => {
        const timer = setInterval(() => {
            handleNext();
        }, 3000); // 3000ms for each slide

        return () => clearInterval(timer); // Cleanup on unmount
    }, []);

    const handleNext = () => {
        // Trigger fade-out
        setFade(true);

        // Change the testimonial after fade-out
        setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
            setFade(false); // Trigger fade-in
        }, 500); // Match this to the CSS animation duration
    };

    const handleDotClick = (index) => {
        setFade(true);
        setTimeout(() => {
            setCurrentIndex(index);
            setFade(false);
        }, 500);
    };
    return (
        <div className='testi-main'>
            <div className="testi-content-main">
                <div className="teasti-content-slider">
                    <div style={styles.slider} className='slider' data-aos="fade-up">
                        <div style={{ ...styles.slide, opacity: fade ? 0 : 1, transition: "opacity 0.5s ease-in-out" }}>
                            <img
                                src={testimonials[currentIndex].image}
                                alt={testimonials[currentIndex].name}
                                style={styles.image}
                            />
                            <p style={styles.text}>"{testimonials[currentIndex].text}"</p>
                            <p style={styles.name}>{testimonials[currentIndex].name}</p>
                            <p style={styles.role}>{testimonials[currentIndex].role}</p>
                        </div>
                    </div>
                </div>
                <div className="testi-content">
                    <div className="testi-head">
                        <p>Testimonial</p>
                        <div className="testi-line"></div>
                    </div>
                    <div className="testi-content1">
                        <div className="testi-content-head" data-aos="fade-up"> 
                            <p>We Are Trusted Over 40+ Countries</p>
                        </div>
                        <div className="testi-content-note" data-aos="fade-up">
                            <p> AIZO Plug is trusted in over 40+ countries for innovative EV charging solutions
                            offering reliable sustainable products since 2015.</p>
                        </div>
                        <div className="testi-content-button">
                            {/* <button>See More</button> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

const styles = {
    slider: {
        width: "500px",
        height: "auto",
        margin: "auto",
        textAlign: "center",
        position: "relative",
        //   background: "black",
        padding: "20px",
        borderRadius: "20px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        // border: "1px solid #30be2e"
    },
    slide: {
        transition: "transform 0.5s ease-in-out",
    },
    image: {
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        //   marginBottom: "15px",
    },
    text: {
        fontSize: "15px",
        //   fontStyle: "italic",
        //   marginBottom: "10px",
        color: "white",
    },
    name: {
        fontWeight: "bold",
        fontSize: "1rem",
        color: "white",
    },
    role: {
        fontSize: "0.9rem",
        color: "white",
    },
};

export default Testimonial